class LocationsController

  @updateSelectOptions: (url, element_id) ->
    $.ajax({
      url: url,
      data: element_id+'=' + $('#'+element_id).val(),
      dataType: 'script'
    })

module.exports = LocationsController
